import React from "react";
import "./share-modal.style.scss";

import {
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
export default function ShareModal({ closeIt, jobId }) {
  return (
    <div onClick={() => closeIt()} className="share-modal-main">
      <div onClick={(e) => e.stopPropagation()} className="share-modal">
        <h4>Share </h4>
        <div className="share-options-wrapper">
          <FacebookShareButton
            url={`https://acads-user.netlify.app/user/description/${jobId}`}
            quote={"Look for a job"}
            hashtag="#job"
            className="share-icon"
          >
            <FacebookIcon size={50} />
          </FacebookShareButton>
          <EmailShareButton
            url={`https://acads-user.netlify.app/user/description/${jobId}`}
            quote={"Look for a job"}
            hashtag="#job"
            className="share-icon"
          >
            <EmailIcon size={50} />
          </EmailShareButton>
          <LinkedinShareButton
            url={`https://acads-user.netlify.app/user/description/${jobId}`}
            quote={"Look for a job"}
            hashtag="#job"
            className="share-icon"
          >
            <LinkedinIcon size={50} />
          </LinkedinShareButton>
          <TelegramShareButton
            url={`https://acads-user.netlify.app/user/description/${jobId}`}
            quote={"Look for a job"}
            hashtag="#job"
            className="share-icon"
          >
            <TelegramIcon size={50} />
          </TelegramShareButton>
          <WhatsappShareButton
            url={`https://acads-user.netlify.app/user/description/${jobId}`}
            quote={"Look for a job"}
            hashtag="#job"
            className="share-icon"
          >
            <WhatsappIcon size={50} />
          </WhatsappShareButton>
        </div>
      </div>
    </div>
  );
}
